import { render, staticRenderFns } from "./SubmittedExpenses.vue?vue&type=template&id=2459c203"
import script from "./SubmittedExpenses.vue?vue&type=script&lang=js"
export * from "./SubmittedExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports